<div class="outer-content">
  <div class="modal card-background-copy" id="modal-dialog" tabindex="-1">
    <form [formGroup]="paymentDetailForm" autocomplete="off" role="form" class=" ">
      <div class="float-left bg-white wd-total">

        <app-content-top-nav [parentElement]="el" [parentFormToValidate]="paymentDetailForm" [visibleBackNav]='true' [enableBackNav]='true' (onBackClickHandler)="backtoPrevious()"></app-content-top-nav>


        <div class="col-md-12 clear-all title-wrapper">
          <h1 class="responsive-text-8" id="payment-header">{{contentData.header}} </h1>
        </div>
        <div class="col-md-12 clear-all content-wrapper margion-top-13">
          <p class="content-top-subtitle" id="payment-introduction">
            {{contentData.introduction}}
          </p>
        
        </div>
        <div class="col-md-12 clear-all content-wrapper displayInline">
          <span class="content-top line-height" id="payment-nonUkBank">
            {{contentData.nonUkBank}}
        </span>
        <div class="Rectangle-checkbox" >
          <!-- <input  type="checkbox" id="check" class="form-control " 
          aria-invalid="false"  (change)="toggleVisibility($event)"/>
        
        <label  for="check" class=" wd-24"></label> -->
        <input type="checkbox" id="accountType" class="form-control " formControlName="accountType" aria-invalid="false"
                    [checked]="dontShowPaymentForm" (change)="toggleVisibility($event)" />
        <label for="accountType" class="form-label wd-25"></label>
        </div>
        
        </div>
      <div *ngIf="!dontShowPaymentForm" class="ipadWidth">
        <div class="col-md-12 clear-all margin-top-30 content-wrapper">

          <div class="col-md-5 clear-all">
            <app-text-input [pageName]="'payment'" [parent]="paymentDetailForm"  [controllerData]="sortCodeconfig" formControlName="sortcode"
              [controlName]="'sortcode'" [isNumeric]="true" (textChangeEventEmitter)="getbankName($event,'sortcode')" >
            </app-text-input>
          </div>
        </div>

        <div class="col-md-12 clear-all margin-top-30 content-wrapper ">

          <div class="col-md-5 clear-all">
            <app-text-input [pageName]="'payment'" [parent]="paymentDetailForm"  [controllerData]="accountNumberCodeConfig" formControlName="accountNumber"
              [controlName]="'accountNumber'" [isNumeric]="true" (textChangeEventEmitter)="getbankName($event,'accountNumber')"  >
            </app-text-input>
          </div>
          <div class="col-md-2 mrg-top">
            <app-tool-tip-notification [childId]="'accountNumberTooltipConfig'" 
                    [tooltipData]="accountNumberTooltipConfig" 
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage('accountNumber')"></app-tool-tip-notification>
          </div>
        </div>

        <div class="col-md-12 clear-all margin-top-30 content-wrapper">

          <div class="col-md-5 clear-all">
            <app-text-input [pageName]="'payment'" [parent]="paymentDetailForm"  [controllerData]="bankNameCodeConfig" formControlName="bankName"
              [controlName]="'bankName'" [isNumeric]="false" >
            </app-text-input>
          </div>
        </div> 
        
        <div  class="col-md-12 clear-all margin-top-30 content-wrapper">

          <div class="col-md-5 clear-all">
            <app-text-input [pageName]="'payment'" [parent]="paymentDetailForm"  [controllerData]="rollNumberCodeConfig" formControlName="rollNumber"
              [controlName]="'rollNumber'" [toUpperCase]="true" [isNumeric]="true">
            </app-text-input>
          </div>
          <div class="col-md-2 mrg-top">
            <app-tool-tip-notification [childId]="'rollNumberTooltipConfig'" 
                [tooltipData]="rollNumberTooltipConfig"
                (onDisplayMobileTooltipEmitter)="displayTooltipMessage('rollNumber')"></app-tool-tip-notification>
          </div>
        </div>  
        <div class="col-md-12 clear-all margin-top-30 content-wrapper">

          <div class="col-md-5 clear-all">
            <app-text-input [pageName]="'payment'" [parent]="paymentDetailForm"  [controllerData]="accountHolderCodeConfig" formControlName="accountHolder"
              [controlName]="'accountHolder'" [toUpperCase]="true" [isNumeric]="false">
            </app-text-input>
          </div>
        </div> 
      </div>

      <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeTooltipModal()"
        (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
        [tooltipFlag]="true"></app-modal>


        <div class="col-md-12 underline margin-top">
        </div>
        <div class="col-md-12 clear-all bottom-container">
          <div class="float-left">
            <app-save [parentElement]="el" [parentFormToValidate]="paymentDetailForm" [location]="'contentBottom'"></app-save>
          </div>
          <div class="float-right">
              <app-content-bottom-nav [disabled]="responseApplicationData['triggeredBy'] === 'HOuser'" (onNextHandler)="gotoNext()" [userInputDetail]="afterApplyDetail['buttonConfig']" [buttonType]="'normalCTA'"></app-content-bottom-nav>
            <!-- <app-content-bottom-nav [userInputDetail]="userInputDetail" (click)="gotoPensionDetails()" [buttonType]="'normalCTA'"></app-content-bottom-nav> -->
          </div>
        </div>
        
        </div>
        </form>
  </div>
</div>